module.exports = __webpack_public_path__ + "img/incident.67c2f29d.png";